import images from 'assets/img'
import Spinner from 'components/Spinner'
import React from 'react'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function EmptyPOS({ t, data }) {
  return (
    <div className="w-full h-72 bg-white flex rounded-xl flex-col">
      <div className="w-full text-center m-auto">
        {
          data ? (<>
            <div className="h-20 w-20 rounded-full bg-default m-auto flex mb-4">
              <img src={images.Calculator} alt="" className="w-10 h-10 m-auto" />
            </div>
            <p className="top-5 text-secondary text-sm">{t('pos.empty')}</p></>) : <Spinner />
        }
      </div>
    </div>
  )
})
